<template>
  <div>
      <Modal :mask-closable="false"  class-name="frame" v-model="modal" 
				:title="title"
        @on-cancel="closeModal"
				:footer-hide = "true"
				:width="modalWidth">
        <iframe id="iframeId" style="border:none;width:100%;" :height='modalHeight'  :src.sync="iframeUrl"></iframe>
			</Modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      modal: true
    }
  },
  props: {
    modalId: '',
    iframeUrl: '',
    title: '',
    modalWidth: '',
    modalHeight: ''
  },
  watch:{
	  iframeUrl (val) {
		  document.getElementById('iframeId').contentWindow.location.reload(true)
	  }
  },
  methods: {
    handleMessage (event) {
      // 根据上面制定的结构来解析iframe内部发回来的数据
      let data = event.data
      if(data.cmd === 'closeGridModal' && data.modalId === this.modalId) {
       this.closeModal()
      }
    },
    closeModal() {
      let frame = document.getElementById('iframeId')
      frame.src = 'about:blank'
      this.modal = false
      this.$emit('closeModal')
      try{
        frame.contentWindow.document.write('')
        frame.contentWindow.document.clear()
      }catch(e){

      }
      frame.contentWindow.close()
    }
  },
  mounted () {
    window.addEventListener('message', this.handleMessage);
  }
}
</script>
<style>
  .frame .ivu-modal-content .ivu-modal-body {
    padding: 0
  }
</style>



// WEBPACK FOOTER //
// src/component/table-grid/components/iframeComponent.vue